import { useState } from 'react';
import { C, Tip } from './constants';

export function SliderInput({ label, value, set, min, max, step, unit, tooltip, group }: any) {
  const g = C.pg[group] || C.pg.opwek;
  const pct = ((value - min) / (max - min)) * 100;
  const decimals = step < 0.1 ? 2 : step < 1 ? 1 : 0;
  const [localVal, setLocalVal] = useState(String(value));
  const [editing, setEditing] = useState(false);

  const commitValue = (raw: string) => {
    const parsed = parseFloat(raw.replace(',', '.'));
    if (isNaN(parsed)) { setLocalVal(value.toFixed(decimals)); return; }
    const clamped = Math.min(max, Math.max(min, parsed));
    set(clamped);
    setLocalVal(clamped.toFixed(decimals));
  };

  const displayVal = editing ? localVal : value.toFixed(decimals);

  return (
    <div className="rounded-[10px] px-3.5 py-2.5" style={{ background: g.bg, border: `1px solid ${g.bdr}` }}>
      <div className="flex justify-between items-center mb-1.5">
        <Tip text={tooltip || label}>
          <span className="text-[11px] font-semibold cursor-help" style={{ color: g.lbl }}>
            {g.ico} {label}
          </span>
        </Tip>
        <div className="flex items-center gap-0.5">
          <input
            type="text"
            inputMode="decimal"
            value={displayVal}
            onFocus={() => { setEditing(true); setLocalVal(value.toFixed(decimals)); }}
            onChange={e => setLocalVal(e.target.value)}
            onBlur={e => { commitValue(e.target.value); setEditing(false); }}
            onKeyDown={e => { if (e.key === 'Enter') { commitValue((e.target as HTMLInputElement).value); setEditing(false); (e.target as HTMLInputElement).blur(); } }}
            className="w-16 text-right text-xs font-bold text-[#0B1F4A] bg-white px-1.5 py-0.5 rounded-md tabular-nums outline-none focus:ring-1 focus:ring-[#00A3C4]"
            style={{ border: `1px solid ${g.bdr}` }}
          />
          <span className="text-[10px] text-[#8899AA]">{unit}</span>
        </div>
      </div>
      <input type="range" min={min} max={max} step={step} value={value}
        onChange={e => set(+e.target.value)}
        className="w-full h-1.5 appearance-none rounded-sm cursor-pointer"
        style={{ background: `linear-gradient(to right, ${C.sec} 0%, ${C.sec} ${pct}%, ${g.bdr} ${pct}%, ${g.bdr} 100%)` }}
      />
      <div className="flex justify-between mt-1">
        <span className="text-[9px] text-[#8899AA]">{min}{unit}</span>
        <span className="text-[9px] text-[#8899AA]">{max}{unit}</span>
      </div>
    </div>
  );
}
